import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'lm-rightview',
  templateUrl: './rightview.component.html',
  styleUrls: ['./rightview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightViewComponent implements OnInit, OnDestroy {
  @Input() top: string = 'base';
  ngOnInit(): void {
    document.body.style.overflowY = 'hidden';
  }
  ngOnDestroy(): void {
    document.body.style.overflowY = 'scroll';
  }
}
